import { createUseStyles } from 'react-jss';
import { setType } from '../styles/mixins/type';

const modalHeaderUseStyles = createUseStyles((theme) => {
  const { bgColor, modal, spacing } = theme;

  return {
    wdsModalAddOn: {
      flexGrow: 1,
      marginTop: spacing[3],
      width: '100%',
      minWidth: '33%',
      textAlign: 'right',

      // In the case that an addon is the first child (modal title was omitted)
      // we do not want a margin top
      '& :first-child': {
        marginTop: 0,
      },
    },
    wdsModalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      padding: spacing[5],
      background: modal.headBgColor,
      flexShrink: 0,
      borderTopLeftRadius: modal.borderRadius,
      borderTopRightRadius: modal.borderRadius,
      borderBottom: `1px solid ${bgColor.accent}`,
    },
    wdsModalText: {
      ...setType(theme, 'sectionTitle'),
      color: modal.headTypeColor,
    },
    wdsModalTitle: {
      flexGrow: 1,
      width: '100%',
    },
    wdsModalSubText: {
      ...setType(theme, 'body'),
      color: modal.headTypeColor,
      margin: [spacing[1], 0, 0],
    },
  };
});

export default modalHeaderUseStyles;
